export default {
  CLICKED: 'clicked',
  CLICKED_FEATURED_POST: 'clicked-featured-post',
  CLICKED_NEWSFEED_ITEM: 'clicked-newsfeed-item',
  CLICKED_NEXT_POST: 'clicked-next-post',
  CLICKED_RELATED_POST: 'clicked-related-post',
  CLICKED_RETENTION_FEED_ITEM: 'clicked-retention-feed-item',
  CLICKED_SEARCH_RESULT: 'clicked-search-result',
  DISMISSED_FEATURED_POST: 'dismissed-featured-post',
  FOLLOWED_USER: 'followed-user',
  PROFILE_SURVEY: 'profile-survey',
  SAW_OOPS_PAGE: 'saw-oops-page',
  SEARCHED_COMMUNITY: 'searched-community',
  SEARCHED_SITE: 'searched-site',
  SIGNED_UP: 'signed-up',
  SKIPPED_FEATURED_POST: 'skipped-featured-post',
  VIEWED_COMMUNITY: 'viewed-community',
  VIEWED_FEATURED_POST: 'viewed-featured-post',
  VIEWED_FEATURED_POST_UNIQUE: 'viewed-featured-post-unique',
  VIEWED_NEWSFEED: 'viewed-newsfeed',
  VIEWED_PAGE: 'viewed-page',
  VIEWED_POST: 'viewed-post',
  VIEWED_TAG_PAGE: 'viewed-tag-page',
  VIEWED_USER: 'viewed-user',
  VIEWED_RETENTION_FEED: 'viewed-retention-feed',
};



// WEBPACK FOOTER //
// ./src/constants/footfallEventTypes.js